import "./App.css";
import GetData from "./GetData";

function App() {
  return (
    <div className="App">
      <div className="weatherCondition">
        <div className="container-1">
          <GetData defaultCity="New York" />

          <div id="forecast"></div>
        </div>
        <div className="footer">
          <strong>
            <span>
              <a
                href="https://gitlab.com/mina-houshmand/weatherapp-react/-/tree/master?ref_type=heads"
                target="_blank"
                className="openSource"
              >
                open-source code
              </a>
            </span>
            &nbsp; &nbsp;
            <span>by Mina Houshmand</span>
          </strong>
        </div>
      </div>
    </div>
  );
}

export default App;
